/**
 * SuperBrain Disclaimer
 * © 2026 A-1 Affiliate Marketing LLC - All Rights Reserved
 */

import React from 'react';
import MachineTranslationNotice from './MachineTranslationNotice';
import './LegalPage.css';

const Disclaimer = () => {
  return (
    <div className="legal-page" data-testid="disclaimer-page">
      <div className="legal-container">
        <button onClick={() => window.history.back()} className="back-btn" data-testid="disclaimer-back-btn">← Back</button>

        <MachineTranslationNotice />

        <h1>DISCLAIMER</h1>
        <p className="subtitle">SuperBrain Agentic Aggregate</p>
        <p className="effective-date">Effective Date: February 11, 2026</p>
        <p className="copyright">© 2026 A-1 Affiliate Marketing LLC. All Rights Reserved.</p>

        <section>
          <h2>1. Informational Use Only</h2>
          <p>SuperBrain Agentic Aggregate provides AI-generated answers synthesized from multiple large language models. All responses are for <strong>informational and educational purposes only</strong>. SuperBrain is not a substitute for professional advice in medical, legal, financial, psychological, or any other licensed field.</p>
        </section>

        <section>
          <h2>2. No Professional Relationship</h2>
          <p>Using SuperBrain does <strong>not</strong> create a doctor-patient, attorney-client, financial advisor, or any other professional relationship. Always consult a licensed professional for decisions that affect your health, finances, legal rights, or wellbeing.</p>
        </section>

        <section>
          <h2>3. Accuracy &amp; Limitations</h2>
          <p>SuperBrain can combine responses from configured AI providers. Synthesis does not verify every claim, and AI output can be:</p>
          <ul>
            <li>Incorrect, outdated, or incomplete</li>
            <li>Biased based on training data</li>
            <li>Confidently wrong (hallucinations)</li>
          </ul>
          <p><strong>Verify critical information independently.</strong> Any consensus indicator and citations are review aids, not proof that a response is correct.</p>
        </section>

        <section>
          <h2>4. Not Financial, Medical, or Legal Advice</h2>
          <p>Any output that resembles financial, medical, legal, tax, investment, or psychological advice is <strong>not</strong> advice. Do not act on SuperBrain output in these domains without confirmation from a licensed practitioner in your jurisdiction.</p>
        </section>

        <section>
          <h2>5. User Responsibility</h2>
          <p>You are solely responsible for how you use SuperBrain's output. A-1 Affiliate Marketing LLC and its operators are not liable for decisions, losses, or damages arising from reliance on AI-generated content.</p>
        </section>

        <section>
          <h2>6. Third-Party AI Providers</h2>
          <p>SuperBrain orchestrates third-party AI services. The underlying model providers each have their own usage policies, content restrictions, and limitations. Generated content may reflect those providers' biases or restrictions.</p>
        </section>

        <section>
          <h2>7. No Warranty</h2>
          <p>SuperBrain is provided "AS IS" without warranty of any kind, express or implied. We do not warrant that the service will be uninterrupted, error-free, or that any specific accuracy threshold will be met for any individual query.</p>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>A-1 Affiliate Marketing LLC<br/>Email: <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default Disclaimer;
